import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      url: '绑定中，请稍候...'
    };
  },
  mounted: function mounted() {
    console.log('code mounted');
    this.getQueryVariable();
  },
  methods: {
    // 获取url参数
    getQueryVariable: function getQueryVariable() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, urlarr, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('getQueryVariable');
              _this.paramRequest = {};
              url = window.location.href.split('?')[1];
              urlarr = url.split('&');
              _iterator = _createForOfIteratorHelper(urlarr);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  _this.paramRequest[item.split('=')[0]] = item.split('=')[1]; // 前者为参数名称，后台为参数值
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              console.log('getQueryVariable', _this.paramRequest);
              _context.next = 9;
              return _this.login();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    } // 获取token
    ,
    login: function login() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('token', localStorage.getItem('token'));
              _this2.$api['wxWebBind'](_this2.paramRequest.code).then(function (res) {
                console.log('login', res, res.data);
                if (res.data) {
                  // this.$router.replace(this.$route.query.redirect || '/')
                  //   if(res.data.userId){
                  //     localStorage.setItem('token', res.data.token)
                  //     window.parent.location.href ='https://gy.rich-link.cn/'
                  //   }else{
                  //     window.parent.location.href ='https://gy.rich-link.cn/login'
                  //     setTimeout(()=>{
                  //       this.$message.info('暂未绑定用户！')
                  //     },500)
                  //   }
                  // this.$message.success('绑定成功！')
                  window.parent.location.href = 'https://gy.rich-link.cn/login?msg=绑定成功！';
                } else {
                  _this2.$message.error(res.msg);
                }
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};